import { useEffect, useState } from "react";
import { MdShoppingCart } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Allapiproduct from "../components/Body/Allapiproduct";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import {
  AddToCart,
  ChangeName,
  MoreData,
  PoductsApi,
  setItemData,
} from "../components/Redux/Action";
import "./../components/Body/Body.css";
import "./ProductsPage.css";

const ProductsPage = () => {
  const hddispatch = useDispatch();
  const Changenames = useSelector((state) => state.ReducerChangeName);
  const [depData, setDepData] = useState(null);
  const [vegproDatamore, setVegproDatamore] = useState();
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [mCount, setMCount] = useState(24);

  async function getProData3(a, b) {
    //0000000001
    let res = await fetch(
      `https://easyapicore.superduper.pk/api/Group/GroupData?BusinessId=0000000001&DepartmentCode=${a}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    res = await res.json();
    const updatedData = res?.data?.map((item) => {
      // if( item?.departmentCode){
      item.isShown = false;

      // }
      return { ...item };
    });

    setDepData(updatedData);
  }

  useEffect(() => {
    getProData3(Changenames.dep, "");
    if (vegproDatamore?.length > 0) {
      if (Changenames.dep == vegproDatamore?.departmentCode) {
      } else {
        setVegproDatamore([]);
        hddispatch(MoreData([]));
        setCount(0);
        // setMCount(24)
      }
    }
    // setDepData(g)
  }, [Changenames.dep]);

  useEffect(() => {
    getProData3(Changenames.dep, "");
    setVegproDatamore([]);
    setCount(0);
    setMCount(13); // ✅ Set to 13 if initial fetch was 1–12
    setHasMore(true);

    hddispatch({
      type: "get_allproducts_data",
      data: [],
    });

    hddispatch(PoductsApi(Changenames.dep, Changenames.grup));
  }, [Changenames.dep, Changenames.grup]);

  return (
    <>
      {/* <Helmet>
        <meta name="description" content="Vape House offers wide variety of E-Liquids Including All The Branded E-Liquids And Much More..Please Click On This Link For More"/>
            <title>Vape House offers wide variety of E-Liquids Including All The Branded E-Liquids And Much More.</title>
        </Helmet> */}

      <Header />

      <div className="productspage">
        <div className="slider-bar">
          <div className="slidebar_conatainer">
            {depData?.map((item, index) => {
              return (
                <Link
                  to={"/productspage"}
                  className="menu_container2"
                  onClick={(e) => {
                    // setValue(depData[index].value = item.departmentCode)
                    // var dep = depData[index].value = item.departmentCode;
                    // var grup = depData[index].value = it.groupCode;
                    setCount(0);
                    // hddispatch(PoductsApi(dep, ''))
                    let data3 = {
                      dep: item.departmentCode,
                      grup: item.groupCode,
                    };
                    hddispatch(ChangeName(data3));
                    //   loadMoreD(item.departmentCode,item.groupCode)

                    setVegproDatamore([]);
                    // e.stopPropagation();
                    hddispatch(PoductsApi(item.departmentCode, item.groupCode));
                  }}
                >
                  <p>{item?.groupName}</p>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="products">
          <div className="subgropRaper">
            <div className="subgropRaperIn1">
              {depData?.map((itm, index) => {
                return (
                  // <Link to={'/productspage'} style={{height:"10px",width:"30px",flexDirection:"row"}}>
                  <div
                    onClick={(e) => {
                      // setValue(depData[index].value = item.departmentCode)
                      // var dep = depData[index].value = item.departmentCode;
                      // var grup = depData[index].value = it.groupCode;
                      setCount(0);
                      // hddispatch(PoductsApi(dep, ''))
                      let data3 = {
                        dep: itm.departmentCode,
                        grup: itm.groupCode,
                      };
                      hddispatch(ChangeName(data3));
                      //   loadMoreD(item.departmentCode,item.groupCode)

                      setVegproDatamore([]);
                      // e.stopPropagation();
                      hddispatch(PoductsApi(itm.departmentCode, itm.groupCode));
                    }}
                    className="subGrouptxt"
                    style={{
                      border: "0.5px solid gray",
                      backgroundColor: "#0d7233",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        color: "white",
                        padding: "10px;",
                      }}
                    >
                      {itm?.groupName}
                    </p>
                  </div>
                  // style={{fontSize:"3px",fontWeight:"bold",color:"red",height:"10px", width:"30%"}}

                  // </Link>
                );
              })}
              {/* <div>jgkjdfkkslkjl</div> */}
            </div>
          </div>
          <h1>{`${Changenames?.department ? Changenames?.department : ""} ${
            Changenames?.group ? "  >  " + Changenames?.group : "Products"
          } ${Changenames?.subgrup ? "  >  " + Changenames?.subgrup : ""}`}</h1>
          <div
            style={{
              paddingTop: "50px",
              backgroundColor: "white",
              flexDirection: "row",
            }}
          >
            <Allapiproduct />
          </div>

          <div
            className="product-main-body"
            style={{ backgroundColor: "white" }}
          >
            {vegproDatamore ? (
              vegproDatamore?.map((item, index) => {
                return (
                  <div className="product_container1">
                    <Link
                      to={"/productdetail"}
                      state={{ item }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        hddispatch(setItemData(item));
                      }}
                    >
                      <img
                        src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                      />
                    </Link>

                    <div
                      className="P-product"
                      style={{
                        color: "black",
                        height: "50px",
                        overflow: "hidden",
                      }}
                    >
                      {item.description}
                    </div>

                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item.unitRetail}
                    </del>
                    <div className="product-cart">
                      <div className="product-cart2">
                        <button
                          style={{ border: "1px solid #F5801E" }}
                          onClick={() => {
                            hddispatch(AddToCart(item));
                            alert("Product Added Successfully");
                          }}
                        >
                          <MdShoppingCart />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ display: count >= 1 ? "block" : "none" }}>
                <ClipLoader color={"red"} loading={true} size={100} />
              </div>
            )}
          </div>

          {Changenames.dep !== "Promotion" &&
            Changenames.dep !== "New Arrivel" &&
            hasMore && (
              <div className="loadd" style={{ textAlign: "center" }}>
                <button
                  style={{
                    border: "0.1px solid",
                    color: "white",
                    backgroundColor: "#005AB5",
                    borderRadius: 10,
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  className={"load-More"}
                  onClick={async () => {
                    const startIndex = mCount;
                    const endIndex = mCount + 14; // loading 15 items

                    const result = await hddispatch(
                      PoductsApi(
                        Changenames.dep,
                        Changenames.grup,
                        "",
                        startIndex,
                        endIndex,
                        true
                      )
                    );

                    if (result < 15) {
                      setHasMore(false); // hide Load More if no more data
                    }

                    setMCount(endIndex + 1); // prepare for next batch
                  }}
                >
                  Load More
                </button>
              </div>
            )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ProductsPage;
